module.exports = __webpack_public_path__ + "img/bloccoApp.93c71f19.png";